<template>
  <div class="line-subscribe py-4">
    <line-button @click="onSubscribe" class="line-subscribe__button">{{
      $t('common.action.subscribeLine')
    }}</line-button>
  </div>
</template>

<script>
import LineButton from '@/components/LineButton.vue'
import { ENV_KEY } from '@/constants/env'
import liff from '@line/liff'

export default {
  components: {
    LineButton,
  },

  created() {
    const redirect = this.$route.query.redirect
    if (redirect) {
      window.location.href = redirect
    }
  },

  methods: {
    onSubscribe() {
      liff.login({
        redirectUri: `${window.location.href}?redirect=https://line.me/R/ti/p/${this.$store.getters['env/GET_KEY'](
          ENV_KEY.LINE_BOT_ID
        )}`,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.line-subscribe {
  &__button {
    @apply w-72;

    @media (min-width: 1024px) {
      width: 360px;
    }
  }
}
</style>
